import { TicketServiceType as r } from "../../../../../../common/shared/ticketServiceType.js";
import { Model as t } from "../../../model.js";
import { getDateTime as s } from "../../../../../utils.js";
class d extends t {
  constructor(e) {
    super(), this.now = e.now, this.readyAt = e.readyAt, this.serviceType = e.serviceType, this.tableId = e.tableId;
  }
  getReadyAtTime(e) {
    return s(this.readyAt, e);
  }
  getServiceKey() {
    switch (this.serviceType) {
      case r.DELIVERY:
        return "delivery";
      case r.DINEIN:
        return "dinein";
      case r.BOOKING:
        return "booking";
      case r.TAKEAWAY:
        return "takeaway";
      default:
        return "unknown";
    }
  }
}
export {
  d as TicketServiceModel
};
//# sourceMappingURL=ticketService.model.js.map
